import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import EditButton from "../../components/Buttons/EditButton";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import {
  useGetAllDesignationsQuery,
  useModifyPersonnelMutation,
} from "../../services/appln";
import Button from "@mui/material/Button";
import ButtonGroup from "../../components/Buttons/ButtonGroup";

interface FormData {
  name: string;
  designationId: string;
  idNumber: string;
  mobileNumber: string;
}

interface Props {
  personnelId: string;
  initialValues: any;
}

export default function EditPersonnel(props: Props) {
  console.log("EditPersonnel, props:", props);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [modifyPersonnel, modifyPersonnelParams] = useModifyPersonnelMutation();
  console.log("EditPersonnel, modifyPersonnelParams:", modifyPersonnelParams);

  React.useEffect(() => {
    if (modifyPersonnelParams.isSuccess) {
      handleClose();
    }
  }, [modifyPersonnelParams]);

  const iv: FormData = {
    name: props.initialValues.row.name,
    idNumber: props.initialValues.row.idNumber,
    mobileNumber: props.initialValues.row.mobileNumber,
    designationId: props.initialValues.row.designationName,
  };

  const designationData = useGetAllDesignationsQuery({
    page: 1,
    limt: 100,
    search: "",
  });

  const designationMap = new Map<string, string>();
  console.log("EditPersonnel, designationMap:", designationMap);
  designationData.data?.data.forEach((element: any) => {
    designationMap.set(element.name, element.id);
  });

  return (
    <div>
      <EditButton onClickHandler={handleClickOpen} />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.editPersonnel}
        </DialogTitle>
        <DialogContent>
          {modifyPersonnelParams.isError && (
            <ErrorMsg msg={strings.failedToEditPersonnel} />
          )}
          {modifyPersonnelParams.isLoading && <ProgressIndicator />}
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.name) {
                errors.name = strings.nameMandatory;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const valuesClone = { ...values };
              valuesClone.designationId = designationMap.get(
                values.designationId,
              )!;
              setSubmitting(false);
              modifyPersonnel({
                personnelId: props.personnelId,
                body: valuesClone,
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="name"
                        name="name"
                        label={strings.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="designationId"
                        value={values.designationId}
                        options={Array.from(designationMap.keys())}
                        renderInput={(params) => (
                          <TextField {...params} label={strings.designation} />
                        )}
                        onChange={(e, value: any) => {
                          setFieldValue("designationId", value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        margin="normal"
                        id="idNumber"
                        name="idNumber"
                        label={strings.idNumber}
                        value={values.idNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.idNumber}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        margin="normal"
                        id="mobileNumber"
                        name="mobileNumber"
                        label={strings.mobileNumber}
                        value={values.mobileNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.mobileNumber}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    <ButtonGroup>
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {strings.save}
                      </Button>
                      <Button variant="contained" onClick={handleClose}>
                        {strings.cancel}
                      </Button>
                    </ButtonGroup>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
